import React, { useEffect } from 'react'
import { Path } from 'react-hook-form'
import { GridHookForm } from 'vnetwork-ui'
import { Contract } from '@/modules/Contract/types'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface VMInstanceCustomizeProps {
    vmName?: string
    data: any
}

const VMInstanceCustomize: React.FC<VMInstanceCustomizeProps> = ({
    vmName,
    data,
}) => {
    const formControl = useFormContext<Contract>()
    const { t } = useTranslation()

    useEffect(() => {
        // @ts-ignore
        formControl.setValue(
            `${vmName}.[${data.vmIndex}].name` as Path<Contract>,
            `vm-custom-${formControl?.watch(`${vmName}.[${data.vmIndex}].vcpu` as Path<Contract>)}-${formControl?.watch(`${vmName}.[${data.vmIndex}].ram` as Path<Contract>)}`
        )
        // @ts-ignore
    }, [
        formControl?.watch(`${vmName}.[${data.vmIndex}].vcpu` as any),
        formControl?.watch(`${vmName}.[${data.vmIndex}].ram` as any),
    ])

    return (
        <GridHookForm
            formControl={formControl}
            subForm={true}
            actions={[]}
            data={[
                {
                    formItemProps: {
                        name: `${vmName}.[${data.vmIndex}].vcpu` as Path<Contract>,
                        type: 'number',
                        label: t('cpu'),
                        placeholder: t('cpu'),
                    },
                    className: 'col-span-1',
                },
                {
                    formItemProps: {
                        name: `${vmName}.[${data.vmIndex}].ram` as Path<Contract>,
                        type: 'number',
                        label: t('memory'),
                        placeholder: t('memory'),
                    },
                    className: 'col-span-1',
                },
                {
                    formItemProps: {
                        name: `${vmName}.[${data.vmIndex}].commitment_price_per_unit` as Path<Contract>,
                        type: 'number',
                        label: t('unit_price'),
                        placeholder: t('unit_price'),
                    },
                    className: 'col-span-2',
                },
            ]}
        />
    )
}

export default VMInstanceCustomize
